export default __webpack_public_path__ + "static/media/shuttle.112ea3ed.png";